import styled from "styled-components";

export const StreamPlayerWrap = styled.div`
  display: flex;
  background: #000;
  width: 100%;
  height: 100%;
`;
